module.exports = __webpack_public_path__ + "static/media/axes.2d34e8f8.png";